import pieImage from './zdjecia/piesPLKT.jpg';
import ogorek from './zdjecia/sezonnieogorek.JPG';
import piesni1 from './zdjecia/piesnirzekifolder/piesni.jpg';
import piesni2 from './zdjecia/piesnirzekifolder/piesni2.jpg';
import piesni3 from './zdjecia/piesnirzekifolder/Julita.jpg';
import piesni4 from './zdjecia/piesnirzekifolder/Krzysztof.jpg';
import piesni5 from './zdjecia/piesnirzekifolder/aniabroda.jpg';
import piesni6 from './zdjecia/piesnirzekifolder/emilia.jpg';
import piesni7 from './zdjecia/piesnirzekifolder/ewa.jpg';
import piesni8 from './zdjecia/piesnirzekifolder/przemek.jpg';
import ogrod from './zdjecia/teatr-w-ogrodzie.jpg'
import nosferat from './zdjecia/Nosferatu2.jpg'
import pierwsze from './zdjecia/teatrpolska/pierwsze.png'
import drugie from './zdjecia/teatrpolska/drugie.jpg'
import min from './zdjecia/dofinasowanie/Logo_MKiDN_RP.png'
import lato from './zdjecia/lato-w-teatrze-logo.png'
import ogrod2 from './zdjecia/teatrogrodkowy.jpg'
import Fest1 from './zdjecia/Festiwale/1.jpg'
import Fest2 from './zdjecia/Festiwale/2.jpg'
import Fest3 from './zdjecia/Festiwale/3.jpg'
import Fest4 from './zdjecia/Festiwale/4.jpg'
import Fest5 from './zdjecia/Festiwale/5.jpg'
import Fest6 from './zdjecia/Festiwale/6.jpg'
import Pod1 from './zdjecia/pod2025/1.jpg'
import Pod2 from './zdjecia/pod2025/2.jpg'
import Pod3 from './zdjecia/pod2025/3.jpg'
import Pod4 from './zdjecia/pod2025/4.jpg'
import Pod5 from './zdjecia/pod2025/5.jpg'
import Pod6 from './zdjecia/pod2025/6.jpg'
import Pod7 from './zdjecia/pod2025/7.jpg'
import Pod8 from './zdjecia/pod2025/8.jpg'
import Pod9 from './zdjecia/pod2025/9.jpg'
import Pod10 from './zdjecia/pod2025/10.jpg'
import Pod11 from './zdjecia/pod2025/11.jpg'
import Pod12 from './zdjecia/pod2025/12.jpg'
import splotyplakat from './zdjecia/spetakle/Plakat_sploty_kopia_optimized_200.jpg'
import splotybaner from './zdjecia/spetakle/sploty_baner.jpg'
import aktualnosci06 from './zdjecia/aktualnosci06.jpg'



const aktualnosciData = [
  {
    id: 14,
    image: aktualnosci06,
    title: "Dom. Posterunkowa 1. Supraśl – Dni Kultury w Supraślu 2026",
    content: "Uwaga! Już w najbliższą sobotę zagramy „𝗗𝗼𝗺 𝗣𝗼𝘀𝘁𝗲𝗿𝘂𝗻𝗸𝗼𝘄𝗮 𝟭. 𝗦𝘂𝗽𝗿𝗮𝘀́𝗹\". Spektakl odbędzie się w ramach 𝗗𝗡𝗜 𝗞𝗨𝗟𝗧𝗨𝗥𝗬 𝗪 𝗦𝗨𝗣𝗥𝗔𝗦́𝗟𝗨 𝟮𝟬𝟮𝟲. 🎭🏡🏡<br/><br/>Sobota 𝟲 𝗰𝘇𝗲𝗿𝘄𝗰𝗮 𝟮𝟬𝟮𝟲 𝗴𝗼𝗱𝘇. 𝟭𝟵:𝟬𝟬 (rezerwacje wyłącznie onlinie, startują 2 czerwca o godz. 11:00, link w komentarzu).<br/><br/>🎫Wstęp 50 zł płatne na miejscu do teatralnego kapelusza🎩.<br/><br/>DNI KULTURY W SUPRAŚLU to cykl wydarzeń kulturalnych organizowanych od 6 do 14 czerwca 2026 roku w różnych miejscach Supraśla. W programie znalazły się spektakle teatralne, wystawy, warsztaty, spacery tematyczne, koncerty i spotkania dla mieszkańców oraz turystów. Wydarzenia przygotowały lokalne instytucje kultury, organizacje i partnerzy działający na terenie miasta.<br/><br/>Szczegóły i aktualny program DKwŚ znajdziecie na stronie organizatora Centrum Kultury i Rekreacji w Supraślu. Zapraszamy!",
    date: "02.06.2026",
    carouselImages: [
      { src: aktualnosci06, alt: "Dom. Posterunkowa 1. Supraśl – Dni Kultury w Supraślu 2026" }
    ]

  },
  {
    id: 13,
    image: splotybaner,
    title: "SPLOTY",
    content: "",
    date: "19.02.2026",
    carouselImages: [
      { src: splotyplakat, alt: "Plakat spektaklu Sploty" },
      { src: splotybaner, alt: "Baner spektaklu Sploty" }

    ]
    
  },
  {
    id: 11,
    image: Pod12,
    title: "Podsumowanie roku 2025",
    content: "",
    date: "01.01.2026",
    carouselImages: [
      { src: Pod11, alt: "Image 0" },
      { src: Pod2, alt: "Image 1" },
      { src: Pod3, alt: "Image 2" },
      { src: Pod4, alt: "Image 3" },
      { src: Pod5, alt: "Image 4" },
      { src: Pod6, alt: "Image 5" },
      { src: Pod7, alt: "Image 0" },
      { src: Pod8, alt: "Image 1" },
      { src: Pod9, alt: "Image 2" },
      { src: Pod10, alt: "Image 3" },
      { src: Pod1, alt: "Image 4" }    ]
    
  },
  {
    id: 10,
    image: Fest6,
    title: "Festiwale… Festiwale czyli Jesień Teatru Łątek",
    content: "",
    date: "20.10.2025",
    carouselImages: [
      { src: Fest6, alt: "Image 0" },
      { src: Fest1, alt: "Image 1" },
      { src: Fest2, alt: "Image 2" },
      { src: Fest3, alt: "Image 3" },
      { src: Fest4, alt: "Image 4" },
      { src: Fest5, alt: "Image 5" }
    ]
    
  },
  
  {
    id: 12,
    image: ogrod2,
    title: "Teatralny Sezon Nieogórkowy – Matecznik, Dom Posterunkowa 1. Supraśl, Nosferatu",
    content: "",
    date: "01.08.2025",
    carouselImages: [
      { src: ogrod2, alt: "Zdjecie plakatu projektu" }
    ]
    
  },
  
  {
    id: 9,
    image: Pod4,
    title: "Teatr Łątek Supraśl - szósty sezon teatralny w najmniejszym teatrze w Polsce",
    content: "",
    date: "08.06.2025",
    carouselImages: [
      { src: Pod4, alt: "Strzałka teatru" }
    ]
    
  },
  {
    id: 8,
    image: min,
    title: "TEATR ŁĄTEK SUPRAŚL Z DOTACJĄ MKIDN W ROKU 2025",
    content: "",
    date: "08.06.2025",
    carouselImages: [
      { src: min, alt: "Logo ministerstwa Kultury" }
    ]
    
  },
  {
    id: 7,
    image: lato,
    title: "Teatr Łątek Supraśl - Lato w teatrze 2025",
    content: "",
    date: "01.06.2025",
    carouselImages: [
      { src: lato, alt: "Logo programu Lato w teatrze" }
    ]
    
  },
  
  
  {
    id: 6,
    image: pierwsze,
    title: "„Matecznik” jedziemy z teatrem. Teatr Polska",
    content: "",
    date: "",
    carouselImages: [
      { src: pierwsze, alt: "Image 1" }
    ]
    
  },
  {
    id: 5,
    image: drugie,
    title: "Teatr Polska - 4 tysiące kilometrów teatralnej podróży",
    content: "",
    date: "",
    carouselImages: [
      { src: pierwsze, alt: "Image 1" }
    ]
    
  },
  {
    id: 4,
    image: nosferat,
    title: "„Nosferatu – dziennik zarazy” realizacja OFF Polska 2024",
    content: "",
    date: "",
    carouselImages: [
      { src: nosferat, alt: "Image 1" }
    ]
  },
  {
    id: 3,
    image: ogrod,
    title: "teatr w ogrodzie",
    content: "",
    date: "",
    carouselImages: [
      { src: ogrod, alt: "Image 1" }
    ]
  },
  {
    id: 1,
    image: pieImage,
    title: "Pieśni Rzeki - rzeka tradycji!",
    content: "",
    carouselImages: [
      { src: pieImage, alt: "Image 1" },
      { src: piesni1, alt: "Image 2" },
      { src: piesni2, alt: "Image 3" },
      { src: piesni3, alt: "Image 4" },
      { src: piesni4, alt: "Image 5" },
      { src: piesni5, alt: "Image 6" },
      { src: piesni6, alt: "Image 7" },
      { src: piesni7, alt: "Image 8" },
      { src: piesni8, alt: "Image 9" }
    ]
  },
  {
    id: 2,
    image: ogorek,
    title: "Teatralny Sezon Nieogórkowy",
    content: "Latem, kiedy większość teatrów zawiesza swoje funkcjonowanie, my działamy w najlepsze i zapraszamy państwa do Teatru Łątek! Na naszej scenie będą pokazywane 4 spektakle z naszego repertuaru: [...]",
    date: "Styczeń 28",
    carouselImages: [
      { src: ogorek, alt: "Image 1" }
    ]
  },
  
  
];

export default aktualnosciData;
